import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Checkout from './pages/Checkout';
import ThankYou from './pages/ThankYou';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/checkout/:cartId" element={<Checkout />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/" element={
            <div className="home-page">
              <div className="home-content">
                <h1>Checkout System</h1>
                <p>Secure checkout powered by Braintree</p>
                <div className="info-box">
                  <h3>For Testing:</h3>
                  <ol>
                    <li>Create a cart via API: <code>POST /api/cart/create</code></li>
                    <li>Use the returned <code>checkout_url</code> to access checkout</li>
                    <li>Test with Braintree sandbox card: <code>4111 1111 1111 1111</code></li>
                  </ol>
                </div>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
